export default __webpack_public_path__ + "static/media/scroll_logo.57ea1da6.svg";